import React from "react";
//#region types
import { SelectionGroupProps } from "models/propTypes/selectionPropTypes";
import { IconDefinitionConstants } from "utils/constants";
//#endregion
//#region components
import Icon from "../icon";
import { Grid, Card, CardContent, ButtonBase } from "@mui/material";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";

const SelectionTiles: React.FC<SelectionGroupProps> = (props) => {
  const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
    const key = e.currentTarget.getAttribute("data-key");

    // eslint-disable-next-line eqeqeq --- disabling to avoid regression testing if changed
    const item = props.items?.find((item) => item.id == key);
    if (item) props.onChange([item]);
  };

  return (
    <React.Fragment>
      <Grid item container className={clsx(cssExports.selectionChipsGroup, props.className)} spacing={2}>
        {props.title ? <div className={cssExports.selectionChipsTitle}>{props.title}</div> : ""}

        {props.items?.length
          ? props.items.map((item) => {
              const isSelected = props.value.find((x) => x.id === item.id);
              return (
                <Grid key={item.id} item xs={item.selectionTileProps?.gridColumnCount ?? 4}>
                  <ButtonBase
                    component={"div"}
                    style={{ display: "block", height: "100%" }}
                    onClick={handleClick}
                    data-key={item.id}
                  >
                    <Card className={clsx(cssExports.selectionTile, isSelected ? cssExports.selected : "")}>
                      <CardContent className={cssExports.selectionTileContent}>
                        <Grid container direction="column">
                          <Grid
                            container
                            direction="row"
                            justifyContent="space-between"
                            alignItems="center"
                            className={cssExports.selectionTileIcons}
                          >
                            {props.icon ? (
                              <Grid item>{props.icon && <Icon icon={props.icon} />}</Grid>
                            ) : (
                              <Grid item className={cssExports.selectionTileText}>
                                {item.value}
                              </Grid>
                            )}

                            <Grid item className={cssExports.selectionIcon}>
                              {isSelected ? (
                                <Icon icon={IconDefinitionConstants.WCheckCanvas} />
                              ) : (
                                <Icon icon={IconDefinitionConstants.WCheckEmpty} />
                              )}
                            </Grid>
                          </Grid>
                          {props.icon ? (
                            <Grid item className={cssExports.selectionTileText}>
                              {item.value}
                            </Grid>
                          ) : (
                            <></>
                          )}
                          <Grid item xs className={cssExports.selectionTileSubText}>
                            {item.description}
                          </Grid>
                        </Grid>
                      </CardContent>
                    </Card>
                  </ButtonBase>
                </Grid>
              );
            })
          : ""}
      </Grid>
    </React.Fragment>
  );
};

export default SelectionTiles;
